export * from './consent-proctoring-page.component';
